import type { RgbaColor } from 'react-colorful';

// Convert any color string to rgba object
export const colorToRgba = (color: string): RgbaColor => {
  // Check if it's rgba format
  const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
  if (rgbaMatch) {
    return {
      r: Number.parseInt(rgbaMatch[1], 10),
      g: Number.parseInt(rgbaMatch[2], 10),
      b: Number.parseInt(rgbaMatch[3], 10),
      a: rgbaMatch[4] ? Number.parseFloat(rgbaMatch[4]) : 1,
    };
  }

  // Check if it's hex format
  const hexMatch = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(color);
  if (hexMatch) {
    return {
      r: Number.parseInt(hexMatch[1], 16),
      g: Number.parseInt(hexMatch[2], 16),
      b: Number.parseInt(hexMatch[3], 16),
      a: hexMatch[4] ? Number.parseInt(hexMatch[4], 16) / 255 : 1,
    };
  }

  return { r: 0, g: 0, b: 0, a: 1 };
};

// Convert rgba object to rgba string (preserves alpha)
export const rgbaToString = (rgba: RgbaColor): string => {
  return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
};

// Convert rgba to hex (for display only)
export const rgbaToHex = (rgba: RgbaColor): string => {
  const toHex = (n: number) => n.toString(16).padStart(2, '0');
  return `#${toHex(rgba.r)}${toHex(rgba.g)}${toHex(rgba.b)}`;
};

// Check if two colors match (including alpha)
export const colorsMatch = (color1: string, color2: string): boolean => {
  const rgba1 = colorToRgba(color1);
  const rgba2 = colorToRgba(color2);
  return rgba1.r === rgba2.r && rgba1.g === rgba2.g && rgba1.b === rgba2.b && Math.abs(rgba1.a - rgba2.a) < 0.01;
};
